import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { map, finalize } from 'rxjs/operators';
import { Customer } from "model/customer";

@Injectable()
export class UserService{

    usuario: Customer;
   
    constructor(){ }
    
    setUser(user : Customer){
        this.usuario = user;
    }
    
    getUser() : Customer{
        return this.usuario;
    }

}    